import { render, staticRenderFns } from "./applet.vue?vue&type=template&id=4f4f850b&scoped=true&"
import script from "./applet.vue?vue&type=script&lang=js&"
export * from "./applet.vue?vue&type=script&lang=js&"
import style0 from "./applet.vue?vue&type=style&index=0&id=4f4f850b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4f850b",
  null
  
)

export default component.exports